import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ApiResponseStatusUnauthorized, ApiResponseSuccess, DropdownPageSizeOptions, EmptyString, SessionStatusOptions } from "utils/Constant";
import { ApiGetDailySessionList, ApiGetUserLocationByUserId, ApiUpdateDailySession } from "utils/constants/api";
import useFetch from "utils/hooks/useFetch";
import FailModal from "components/modal/FailModal";
import LoadingModal from "components/modal/LoadingModal";
import SuccessModal from "components/modal/SuccessModal";
import ConfirmationModal from "components/modal/ConfirmationModal";
import DatePicker from "components/Input/DatePicker";
import moment from "moment";
import Dropdown from "components/Input/Dropdown";

export default function Session(){
    let navigate = useNavigate()

    const { fetch: apiGetDailySessionList } = useFetch(ApiGetDailySessionList)
    const { fetch: apiUpdateDailySession } = useFetch(ApiUpdateDailySession)
    const { fetch: apiGetUserLocation } = useFetch(ApiGetUserLocationByUserId)

    const [transactionalDateFilter, setTransactionalDateFilter] = useState(new Date())
    const [sessionList, setSessionList] = useState([])
    const [sessionStatus, setSessionStatus] = useState('')
    const [pageSize, setPageSize] = useState(DropdownPageSizeOptions[0].value)
    const [locationOptions, setLocationOptions] = useState([])
    const [location, setLocation] = useState(EmptyString)
    const [isFirstLoad, setIsFirstLoad] = useState(true)

    // Modal
    const [failModal, setFailModal] = useState({ isOpen: false, data: {}, message: EmptyString })
	const [loading, setLoading] = useState({isOpen: false})
    const [successModal, setSuccessModal] = useState({ isOpen: false, data: {} })
    const [confirmationModal, setConfirmationModal] = useState({ isOpen: false, data: {} })

    // Button Event
    const openSessionBtnClick = (id) => {
        setConfirmationModal({
            isOpen: true,
            data: {
                onSuccess: async () => {
                    setConfirmationModal({ isOpen: false })
                    setLoading({ isOpen: true })

                    updateDailySession(id, '0001-01-01T00:00', '0').then(() => {
                        getDailySessionList().then(() => {
                            setLoading({ isOpen: false })
                        })
                    })
                }
            }
        })
    }
    const closeSessionBtnClick = (id) => {
        setConfirmationModal({
            isOpen: true,
            data: {
                onSuccess: async () => {
                    setConfirmationModal({ isOpen: false })

                    setLoading({ isOpen: true })

                    updateDailySession(id, moment(new Date()).format("YYYY-MM-DDTHH:mm"), '1').then(() => {
                        getDailySessionList().then(() => {
                            setLoading({ isOpen: false })
                        })
                    })
                }
            }
        })
    }

    // API Calls
    const getDailySessionList = async() => {
        await apiGetDailySessionList({
            data: {
                transactionalDate: transactionalDateFilter,
                sessionStatus,
                pageSize,
                locationId: location
            }
        }).then((response) => {
            if (checkResponse(response)) {
                setSessionList(response.data)
            }
        })
    }
    const updateDailySession = async(id, sessionEnd, sessionStatus) => {
        await apiUpdateDailySession({
            data: {
                dailySessionId: id, 
                sessionEnd: sessionEnd, 
                sessionStatus: sessionStatus
            }
        }).then((response) => {
            if (checkResponse(response)) {
                setSuccessModal({ 
                    isOpen: true, 
                    data: {
                        onSuccess: async () => {
                            setSuccessModal({ isOpen: false })
                        }
                    }
                })
            }
        })
    }
    const getUserLocationList = async() => {
        await apiGetUserLocation({
            data: {
                userId: localStorage.getItem('Id')
            }
        }).then((response) => {
            if (checkResponse(response)) {
                let tempArray = []
                tempArray.push({label: "All", value: ""})

                for (let i = 0; i < response.data.length; i++){
                    tempArray.push({ label: response.data[i].locationName, value: String(response.data[i].locationId) })
                }

                setLocationOptions(tempArray)
                setLocation(tempArray[0].value)
            }
        })
    }

    const checkResponse = (res) => {
        if(res.status === ApiResponseSuccess){
            return true
        }else if(res.status === ApiResponseStatusUnauthorized){
            setFailModal({
                isOpen: true,
                data: {
                    onSuccess: async () => {
                        setFailModal({isOpen: false})
                        window.location.href = "/login"
                    }
                },
                message: res.message
            })
            return false
        }else{
            setFailModal({
                isOpen: true,
                data: {
                    onSuccess: async () => {
                        setFailModal({isOpen: false})
                    }
                },
                message: res.message
            })
            return false
        }
    }

    useEffect(() => {
        setLoading({ isOpen: true })
        
        if (isFirstLoad){
            getUserLocationList().then(() => {
                getDailySessionList().then(() => {
                    setLoading({ isOpen: false })
                })
                setIsFirstLoad(false)
            })
        } else {
            getDailySessionList().then(() => {
                setLoading({ isOpen: false })
            })
        }        
    },[transactionalDateFilter, pageSize, sessionStatus, location])

    
    return(
        <div className="flex flex-col gap-2">
            <div >
                <span className="font-semibold text-xl sm:text-2xl">Session</span>
            </div>
            <hr />

            {/* FILTER */}
            <div className="flex flex-col sm:flex-row justify-between gap-8 sm:mt-5">
                <div className="flex flex-col sm:flex-row gap-2 sm:gap-4 sm:flex-wrap w-full">
                    <CardFilter title='Location'>
                        <Dropdown 
                            options={locationOptions}
                            value={location} 
                            onChange={(e) => setLocation(e.value)} 
                            className="w-full rounded h-10 bg-white" 
                            placeholder={'All'}
                        />
                    </CardFilter>

                    <CardFilter title='Session Status'>
                        <Dropdown 
                            options={SessionStatusOptions}
                            value={sessionStatus} 
                            onChange={(e) => setSessionStatus(e.value)} 
                            className="w-full rounded h-10 bg-white" 
                            placeholder={'All'}
                        />
                    </CardFilter>

                    <CardFilter title='Show'>
                        <Dropdown 
                            options={DropdownPageSizeOptions}
                            value={pageSize} 
                            onChange={(e) => setPageSize(e.value)} 
                            className="w-full rounded h-10 bg-white"
                        />
                    </CardFilter>
                </div>
            </div>
           
            <div className="mt-5 overflow-hidden sm:border sm:rounded-3xl sm:shadow-sm text-sm sm:text-base">
                {/* MOBILE SIZE VIEW */}
                <div className="sm:hidden w-full">
                    { sessionList?.map((data, i) => {
                        return(
                            <div className="w-full border-t py-2 flex flex-col">
                                <div className="flex justify-between items-center">
                                    <div>
                                        <span className="font-semibold">{ data.locationName }</span>
                                    </div>
                                    <div>
                                        <span className={`py-1 text-xs px-4 rounded-full ${data.sessionStatus === "0" ? 'bg-yellow-400 border-none' : 'bg-gray-300'}`}>
                                            { data.sessionStatus === "0" ? 'OPEN' : 'CLOSED' }
                                        </span>
                                    </div>
                                </div>

                                <div className="flex justify-between items-center">
                                    <div>
                                        <span className="text-xs font-semibold">{ moment(data.transactionalDate).format("DD MMM yyyy") }</span>
                                    </div>
                                    <div>
                                        
                                    </div>
                                </div>
                                
                                <div className="flex justify-between items-center">
                                    <div>
                                        <span className={`text-xs text-gray-600`}>
                                            { moment(data.sessionStart).format("DD MMM yyyy HH:mm") }
                                        </span>
                                    </div>
                                    <div>
                                        <span className={`text-xs text-gray-600`}>
                                            { moment(data.sessionEnd).format("DD MMM yyyy") === '01 Jan 0001' ? '-' : moment(data.sessionEnd).format("DD MMM yyyy HH:mm") }
                                        </span>
                                    </div>
                                </div>

                                <div className="flex justify-end items-center text-sm">
                                    <button className={`bg-black py-1 px-2 rounded text-white flex gap-2 ${data.sessionStatus === '0' ? 'hidden' : 'block'} `} 
                                        onClick={() => openSessionBtnClick( data.dailySessionId )}>
                                        <span className="text-xs">Open Session</span>
                                    </button>
                                    <button className={`bg-black py-1 px-2 rounded text-white flex gap-2 ${data.sessionStatus === '1' ? 'hidden' : 'block'} `} 
                                        onClick={() => closeSessionBtnClick( data.dailySessionId )}>
                                        <span className="text-xs">Close Session</span>
                                    </button>
                                </div>
                            </div>
                        )
                    })}
                </div>

                {/* WEB VIEW */}
                <table className="w-full bg-white hidden sm:table">
                    <thead className="rounded-xl">
                        <tr className="h-12 rounded">
                            <th className="font-semibold w-16">No</th>
                            <th className="font-semibold text-left px-2">Transactional Date</th>
                            <th className="font-semibold text-left px-2">Location</th>
                            <th className="font-semibold text-left px-2">Session Start</th>
                            <th className="font-semibold text-left px-2">Session End</th>
                            <th className="font-semibold text-left px-2">Session Status</th>
                            <th className="font-semibold text-left px-2">Create By</th>
                            <th className="font-semibold text-center px-2">Action</th>
                        </tr>
                    </thead>
                    <tbody className="">
                        { sessionList?.length < 1 && (
                            <tr className="border-t">
                                <td colSpan={9} className="text-center py-3">
                                    <span>No Data Available</span>
                                </td>
                            </tr>
                        )}
                        { sessionList?.map((data, i) => {
                            return(
                                <tr className="my-2 row h-10 border-t hover:bg-slate-100 " key={ i }>
                                    <td className="text-center">{ i + 1 }</td>
                                    <td className="px-2">
                                        <span>{ moment(data.transactionalDate).format("DD MMM yyyy") }</span>
                                    </td>
                                    <td className="px-2">
                                        <span>{ data.locationName }</span>
                                    </td>
                                    <td className="px-2">
                                        <span>{ moment(data.sessionStart).format("DD MMM yyyy HH:mm") }</span>
                                    </td>
                                    <td className="px-2">
                                        <span>{ moment(data.sessionEnd).format("DD MMM yyyy") === '01 Jan 0001' ? '-' : moment(data.sessionEnd).format("DD MMM yyyy HH:mm") }</span>
                                    </td>
                                    <td className="px-2">
                                        <span className={`py-1 text-sm px-4 rounded-full ${data.sessionStatus === "0" ? 'bg-yellow-400 border-none' : 'bg-gray-300'}`}>
                                            { data.sessionStatus === "0" ? 'Open' : 'Closed' }
                                        </span>
                                    </td>
                                    <td className="px-2">
                                        <span>{ data.createdBy }</span>
                                    </td>
                                    <td className="flex justify-center py-2 gap-2 px-2 text-xs">
                                        <button className={`button flex gap-2 ${data.sessionStatus === '0' ? 'hidden' : 'block'} `} 
                                            onClick={() => openSessionBtnClick( data.dailySessionId )}>
                                            <span>Open Session</span>
                                        </button>
                                        <button className={`button flex gap-2 ${data.sessionStatus === '1' ? 'hidden' : 'block'} `} 
                                            onClick={() => closeSessionBtnClick( data.dailySessionId )}>
                                            <span>Close Session</span>
                                        </button>
                                    </td>
                                </tr>
                            )
                        })}
                    </tbody>
                </table>
            </div>

            {/* Modal */}
			{failModal.isOpen && ( <FailModal onClose={() => setFailModal({ isOpen: false, data: {}, message: EmptyString })} data={failModal?.data} message={failModal?.message} /> )}
			{loading.isOpen && (<LoadingModal onClose={() => setLoading({ isOpen: false })} />)}
            {successModal.isOpen && ( <SuccessModal onClose={() => setSuccessModal({ isOpen: false, data: {} })} data={successModal?.data} /> )}
            {confirmationModal.isOpen && ( <ConfirmationModal onClose={() => setConfirmationModal({ isOpen: false, data: {} })} data={confirmationModal?.data} /> )}
        </div>
    )
}

const CardFilter = ({ title, children }) => {
    return(
        <div className="flex flex-col gap-1 w-full sm:w-[240px] text-sm sm:text-base">
            <span>{ title }</span>
            { children }
        </div>
    )
}